import { render, staticRenderFns } from "./dispatch_info.vue?vue&type=template&id=2ad30909&scoped=true"
import script from "./dispatch_info.vue?vue&type=script&lang=js"
export * from "./dispatch_info.vue?vue&type=script&lang=js"
import style0 from "./dispatch_info.vue?vue&type=style&index=0&id=2ad30909&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad30909",
  null
  
)

export default component.exports